<template>
	<div>
		<v-dialog v-model="transtypes" no-click-animation scrollable persistent content-class="full-height select_field_dialog" transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
	        	<v-subheader full-width>Select Type</v-subheader>
	        </v-card-title>
	        <v-divider></v-divider>
	        <!-- <v-card-text nopadding single-selection-dialog full-height right-align-radio> -->
	        <v-card-text full-height nopadding>

	        	<v-list nopadding>
		        	<v-list-tile v-for="(item, index) in transactionTypes" :key="index" @click="fn_setTransactionType(item.value)">

			            <v-list-tile-content>
			              <v-list-tile-title>{{item.value}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="item.value == $parent.Form.particularsData.transType">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>
		        	</v-list-tile>
		        </v-list>
	          	<!-- <v-radio-group column form-item v-model="$parent.Form.particularsData.transType" full-width-label>
	          		<v-radio :label="item.value" :value="item.value" v-for="(item, index) in transactionTypes" :key="index" @change="$parent.fn_closeDialog"></v-radio>
	          	</v-radio-group> -->
	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">Close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>
	
<script>
	export default{
		data(){
			return{
				transtypes:false,
				transactionTypes:[
					{"id":1, "value":"Cheque"},
					{"id":2, "value":"DD"},
					{"id":3, "value":"RTGS"},
					{"id":4, "value":"NEFT"},
					{"id":5, "value":"Others"},
				]
			}
		},
		methods:{
			openDialogWeb: function () {
				this.transtypes = true;
			},
			closeDialogWeb: function () {
				this.transtypes = false;
			},
			fn_setTransactionType: function(value){
				this.$parent.Form.particularsData.transType = value;
				this.$parent.fn_closeDialog();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/accountbooks/dialogs/dialog_bank_trans_types.vue